var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import AntdNotification from 'antd/es/notification';
import classnames from 'classnames';
import { globalConfig } from '../config-provider';
import { CheckFillIcon, CloseFillIcon, CloseIcon, InfoFillIcon, WarningFillIcon } from '../icon';
const noticeTypes = ['info', 'success', 'error', 'warning'];
const formatParams = (config, type) => {
    const noticeIcon = {
        success: React.createElement(CheckFillIcon, null),
        warning: React.createElement(WarningFillIcon, null),
        error: React.createElement(CloseFillIcon, null),
        info: React.createElement(InfoFillIcon, null)
    };
    const { className: outerClassName, prefixCls: customizePrefixCls } = config, rest = __rest(config, ["className", "prefixCls"]);
    const { getPrefixCls } = globalConfig();
    const prefixCls = getPrefixCls('notification', customizePrefixCls);
    const className = classnames(prefixCls, outerClassName);
    return Object.assign({ className, icon: type ? noticeIcon[type] : undefined, closeIcon: React.createElement(CloseIcon, null) }, rest);
};
const getNotificationInstance = (notification) => {
    const noticeInstance = {
        open: (config) => {
            const params = formatParams(config);
            return notification.open(params);
        }
    };
    noticeTypes.forEach((type) => {
        noticeInstance[type] = (config) => {
            const params = formatParams(config, type);
            return notification[type](params);
        };
    });
    return noticeInstance;
};
const notificationInstance = getNotificationInstance(AntdNotification);
const Notification = Object.assign(Object.assign(Object.assign({}, AntdNotification), notificationInstance), { warn: notificationInstance.warning, useNotification: () => {
        const [notificationHooksApi, contextHolder] = AntdNotification.useNotification();
        return [getNotificationInstance(notificationHooksApi), contextHolder];
    } });
Notification.config({ duration: 3 });
export default Notification;
